import { Avatar, Popover } from "antd";
import React, { memo, useEffect, useState } from "react";
import { clearSessionStorage } from "../../utilities/helper";
import { useNavigate } from "react-router-dom";
import { ROUTES, TOKENS } from "../../utilities/Constants/Constants";
import Profile from "../../assets/icons/user-profile.svg";
import DropDownIcon from "../../assets/icons/chevron-down.svg";
import DropUpIcon from "../../assets/icons/chevron-down.svg";
import signout from "../../assets/icons/sign-out.svg";
import { useGetAdminProfileQuery } from "../../service/apiSlices/dashboard";
import {
  setProfileImage,
  setProfileName,
} from "../../service/apiSlices/staticApi";
import { useDispatch } from "react-redux";
import EditProfileModal from "../EditProfileModal/EditProfileModal";

const UserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = sessionStorage.getItem(TOKENS.ACCESS_TOKEN);

  const [open, setOpen] = useState(false);
  const [isEditModelOpen, setIsEditModelOpen] = useState<boolean>(false);
  const [accProfileImage, setaccProfileImage] = useState("");
  const [adminProfileData, setAdminProfileData] = useState<any>("");
  const [accProfileDesignation, setAccProfileDesignation] = useState("");
  const [accProfileName, setAccProfileName] = useState("");

  const { data: adminData, refetch: refetchAdminProfile } =
    useGetAdminProfileQuery("");

  useEffect(() => {
    if (adminData && adminData?.data?.firstname) {
      const fullName =
        `${adminData?.data?.firstname} ${adminData?.data?.lastname}`.trim();
        const profileImageURL = adminData?.data?.profile_image;
        setAccProfileName(fullName);
        dispatch(setProfileName(fullName));
        dispatch(setProfileImage(profileImageURL));
        setaccProfileImage(profileImageURL);
        setAccProfileDesignation(adminData?.data?.designation);
        setAdminProfileData(adminData?.data);
    }
}, [adminData, dispatch]);

useEffect(() => {
    if (
        token &&
        adminData &&
        (adminData?.data?.firstname === "" ||
            adminData?.data?.firstname === null ||
            adminData?.data?.firstname === undefined)
        ) {
            setIsEditModelOpen(true);
        }
    }, [adminData, token]);

  const handleModalClose = async () => {
    setIsEditModelOpen(false);
    await new Promise((resolve) => setTimeout(resolve, 0));
    await refetchAdminProfile();
  };

  const onLogOut = () => {
    clearSessionStorage();
    navigate(ROUTES.LOGIN);
  };

  const editProfile = () => {
    setOpen(false);
    setIsEditModelOpen(true);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  function handleEdit(): void {
    // throw new Error("Function not implemented.");
  }

  const content = (
    <>
      <p onClick={editProfile} className="user-actions-item">
        <img src={Profile} alt="edit-profile" /> Edit profile
      </p>
      <div className="divider"></div>
      <p onClick={onLogOut} className="user-actions-item">
        <img src={signout} alt="signout" /> Sign Out
      </p>
    </>
  );

  return (
    <div>
      <div className="user-profile">
        {!accProfileImage ? (
          <Avatar>{`${adminData?.result?.data?.first_name?.charAt(0)}${adminData?.result?.data?.last_name?.charAt(0)}`}</Avatar>
        ) : (
          <Avatar src={accProfileImage} size={32} />
        )}
        <div className="">
          <p className="mb-0 user-name">
            {accProfileName ? accProfileName : "New User"}
          </p>
          <p className="mb-0 designation mt-1">
            {accProfileDesignation ? accProfileDesignation : "user"}
          </p>
        </div>
        <Popover
          content={content}
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomLeft"
          overlayClassName="headerUserActions"
          arrow={false}
        >
          <a onClick={(e) => e.preventDefault()}>
            <img
              src={open ? DropUpIcon : DropDownIcon}
              alt="down-arrow"
              className={open ? "dropDownOpen" : "dropDownClose"}
            />
          </a>
        </Popover>
      </div>
      <EditProfileModal
        visible={isEditModelOpen}
        onConfirm={handleEdit}
        onCancel={handleModalClose}
        title={""}
        content={""}
        okText={"Confirm"}
        cancelText={"Cancel"}
        userProfileData={adminProfileData}
      />
    </div>
  );
};

export default memo(UserProfile);
